// « Entraînement » hub (#/entrainement?r=semaine|historique|exercices), refonte navigation 21/10 (spec ARBORESCENCE-ACS §3).
// The rubrique lives in the URL (?r=, domains.ts useRubrique); the LOCAL dock (Ma semaine · Historique · Exercices) is the shell's.
// One common header (title of the domain + ShellActions); each rubrique is its own file:
// - Ma semaine: entrainement-semaine.tsx (agenda, small-group slots with their séance, personal séances);
// - Historique: entrainement-historique.tsx (assiduité, month synthesis, performance.tsx, realised sessions, past bookings);
// - Exercices: entrainement-exercices.tsx (bank + video / PDF resources; fiches unchanged).
// The former three-block hub (planning + Mon programme + Pour tes séances) is superseded; SharedPlanning stays in planning.tsx.
import "./hub-entrainement.css";
import { StatusBar, type Route } from "./parts";
import { HubHead, ShellActions } from "./shell";
import { useRubrique } from "./domains";
import { MaSemaine } from "./entrainement-semaine";
import { Historique } from "./entrainement-historique";
import { Exercices } from "./entrainement-exercices";

interface PageProps { go: (route: Route) => void; onOutOfScope: (label: string) => void }

const TITLE: Record<string, string> = { semaine: "Ma semaine", historique: "Historique", exercices: "Exercices" };

export function Entrainement(_: PageProps) {
  const rub = useRubrique("entrainement");
  return <div className="cc-screen cc-account cc-entrainement cc-ent-hub" data-rub={rub}>
    <StatusBar />
    <div className="cc-scroll">
      <HubHead domain="entrainement" />
      <div key={rub} className="cc-ent-body">
        {rub === "historique" ? <Historique /> : rub === "exercices" ? <Exercices /> : <MaSemaine />}
      </div>
    </div>
  </div>;
}
